// The backend runs the same contract and validator before proposal and approval.
const contract = require('./contract.json');
const record = (value) => !!value && typeof value === 'object' && !Array.isArray(value);
const own = (value, key) => Object.prototype.hasOwnProperty.call(value, key);
const slugPattern = /^[a-z][a-z0-9]*(?:-[a-z0-9]+)*$/;
function validateAppScreens(value) {
  const errors = [];
  const fail = (message) => { if (errors.length < 20) errors.push(message); };
  if (value === null) return { errors, warnings: [] };
  if (!record(value) || value.version !== contract.version || !Array.isArray(value.screens)) return { errors: ['Unsupported screen configuration.'], warnings: [] };
  let size;
  try { size = JSON.stringify(value).length; } catch { return { errors: ['Screen configuration must be JSON.'], warnings: [] }; }
  if (size > 200000 || value.screens.length > 20) return { errors: ['Use at most 20 screens and 200 KB of content.'], warnings: [] };
  if (Object.keys(value).some(key => !['version', 'screens'].includes(key))) fail('Unknown screen configuration field.');
  const slugs = new Set();
  const targets = new Set();
  const destinations = [];
  for (const screen of value.screens) {
    if (!record(screen)) { fail('Invalid screen.'); continue; }
    if (Object.keys(screen).some(key => !['target', 'slug', 'title', 'menuLabel', 'menuOrder', 'showInMenu', 'enabled', 'data'].includes(key))) fail('Unknown screen field.');
    if (!['custom', 'home'].includes(screen.target)) fail('Unknown screen target.');
    if (screen.target === 'home') {
      if (targets.has('home') || screen.slug !== 'home') fail('Only one Home layout is allowed.');
      targets.add('home');
    }
    if (typeof screen.slug !== 'string' || screen.slug.length > 64 || !slugPattern.test(screen.slug) || slugs.has(screen.slug)) fail('Screen URLs must be unique lowercase words separated by hyphens.');
    slugs.add(screen.slug);
    for (const key of ['title', 'menuLabel']) if (typeof screen[key] !== 'string' || !screen[key].trim() || screen[key].length > 80) fail('Screen and menu names must contain 1–80 characters.');
    if (!Number.isInteger(screen.menuOrder) || screen.menuOrder < 0 || screen.menuOrder > 999) fail('Menu order must be a whole number from 0 to 999.');
    if (typeof screen.enabled !== 'boolean' || typeof screen.showInMenu !== 'boolean') fail('Screen visibility must be true or false.');
    const ids = new Set();
    let count = 0;
    const homeBlocks = [];
    function fields(props, definitions, depth) {
      if (!record(props)) { fail('Invalid component properties.'); return; }
      if (own(props, 'id') && (typeof props.id !== 'string' || !/^[a-zA-Z0-9_-]{1,100}$/.test(props.id))) fail('Invalid component ID.');
      if (Object.keys(props).some(key => key !== 'id' && !own(definitions, key))) fail('Unknown component property.');
      for (const [key, field] of Object.entries(definitions)) {
        const token = props[key];
        if (token === undefined) continue;
        if (field.type === 'slot') { nodes(token, depth + 1); continue; }
        const valid = field.type === 'number' ? Number.isInteger(token) && token >= field.min && token <= field.max
          : field.type === 'choice' ? field.options.includes(token)
          : field.type === 'destination' ? typeof token === 'string' && (['plans', 'settings'].includes(token) || /^screen:[a-z][a-z0-9-]{0,63}$/.test(token))
          : typeof token === 'string' && token.length <= field.max;
        if (!valid) fail(`Invalid ${field.label}.`);
        else if (field.type === 'destination') destinations.push(token);
      }
    }
    function nodes(items, depth) {
      if (!Array.isArray(items) || depth > 8) { fail('Use valid blocks nested no more than eight levels deep.'); return; }
      for (const node of items) {
        if (++count > 100) { fail('Use at most 100 blocks per screen.'); return; }
        if (!record(node) || !own(contract.components, node.type) || Object.keys(node).some(key => !['type', 'props'].includes(key))) { fail('Unknown screen component.'); continue; }
        const target = contract.components[node.type].target;
        if (target && screen.target !== target) fail('This component belongs to another screen.');
        if (target === 'home') homeBlocks.push(node.type);
        const id = node.props?.id;
        if (typeof id !== 'string' || !/^[a-zA-Z0-9_-]{1,100}$/.test(id) || ids.has(id)) fail('Each component needs a unique ID.');
        ids.add(id);
        fields(node.props, contract.components[node.type].fields, depth);
      }
    }
    if (!record(screen.data) || Object.keys(screen.data).some(key => !['root', 'content'].includes(key)) || !record(screen.data.root) || Object.keys(screen.data.root).some(key => key !== 'props')) { fail('Invalid screen layout.'); continue; }
    fields(screen.data.root.props, contract.root, 0);
    nodes(screen.data.content, 0);
    if (screen.target === 'home' && ['HomeWelcome', 'HomeSetup', 'HomeNextActions'].some(type => homeBlocks.filter(block => block === type).length !== 1)) fail('Home must keep exactly one welcome, first plan setup, and next steps block.');
  }
  if (destinations.some(target => target.startsWith('screen:') && !slugs.has(target.slice(7)))) fail('A button points to a screen that does not exist.');
  return { errors, warnings: [] };
}
module.exports = { validateAppScreens };
